import { useState, useEffect } from 'react';
import { Session } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';

export function useAuth() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Try to recover session from refresh token
    const refreshToken = localStorage.getItem('sb-refresh-token');
    if (refreshToken) {
      supabase.auth.refreshSession().catch(() => {
        // If refresh fails, remove the invalid token
        localStorage.removeItem('sb-refresh-token');
      });
    }

    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      // Store refresh token when session changes
      if (session?.refresh_token) {
        localStorage.setItem('sb-refresh-token', session.refresh_token);
      }
      setSession(session);
      setLoading(false);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return { session, loading };
}